import moment from 'moment';

const format = 'YYYY-MM-DD';

export const formatDate = (date: Date) => {
   return moment(date).format(format);
};
